import { useEffect, useState } from "react";
import { waitFor } from "./waitFor";

// eslint-disable-next-line import/prefer-default-export
export const useJuicySessionId = (skip = false) => {
  const [juicySessionId, setJuicySessionId] = useState(null);

  const getId = async () => {
    try {
      const jslabApi = await waitFor(() => window.jslabApi, 50);

      let id = jslabApi.getSession();

      if (!id) {
        // eslint-disable-next-line no-console
        console.log("Juicy Session is empty, waiting for it");
        id = await waitFor(() => jslabApi.getSession(), 50);
      }

      setJuicySessionId(id);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("juicyScore sessionId", e);
    }
  };

  useEffect(() => {
    if (!juicySessionId && !skip) {
      getId();
    }
  }, [skip]);

  return juicySessionId;
};
